import { useGeckoLocale } from 'features/locale'
import { GeckoMeasurementSystem } from 'types'

import { AssetVizToolbarToggle } from './AssetVizToolbarToggle'

/**
 * In/mm units toggle for the asset-viz toolbar. Drives the app-wide measurement
 * system via `useGeckoLocale`, so the whole viz pane (and app) re-renders in the
 * chosen unit. Owns the locale dependency so the toolbar surface stays
 * presentational.
 */
export function AssetVizUnitsToggle() {
  const { measurementSystem, setMeasurementSystem } = useGeckoLocale()
  return (
    <AssetVizToolbarToggle
      ariaLabel='Measurement units'
      value={measurementSystem}
      onChange={setMeasurementSystem}
      options={[
        { value: GeckoMeasurementSystem.Imperial, label: 'in' },
        { value: GeckoMeasurementSystem.Metric, label: 'mm' },
      ]}
    />
  )
}
